module.exports = __webpack_public_path__ + "assets/img/page_3.ba705465.png";